import actions from "./actions";

const initState = {
    createAssetTypeState: null,
    readAssetTypeListState: null,
    assetTypes: [],
    readAssetTypeState: null,
    assetType: {
        default_depreciation_method: 'STRAIGHT_LINE',
        default_depreciation_convention: 'FULL_MONTH',
        default_depreciate_mode: 'PERIOD',
        default_useful_life: '5;0',
    },
    assetTypeDepreciateMode: 'PERIOD',
    updateAssetTypeState: null,
    deleteAssetTypeState: null,
    depreciationDates: [],
    readAssetDepreciationDateListState: null,
    previewAssetDepreciationState: null,
    previewDepreciations: [],
    createAssetDepreciationState: null,
    deleteAssetDepreciationListState: null,
    readPurchaseListState: null,
    purchases: [],
    createAssetState: null,
    createBulkAssetState: null,
    readAssetListState: null,
    assets: [],
    pagination: {},
    lastDepreciated: null,
    readAssetState: null,
    asset: {},
    depreciations: [],
    assetDepreciateMode: 'PERIOD',
    assetPurchaseDate: null, // string
    assetDepreciationStartDate: null, // string
    assetIsDepreciated: null,
    disposal: {},
    disposalAmount: null,
    disposalLastDepreciationType: null,
    disposalLastDepreciationDate: null, // string
    updateAssetState: null,
    deleteAssetState: null,
    disposeAssetState: null,
    undisposeAssetState: null,

    /* Editable Table Related */
    items: [],
    editLine: null,
    focusedElement: null,
};

let idx, items, item;

export default function appReducer(state = initState, action = {}) {
    switch (action.type) {
    /* ASSET TYPES */
        case actions.ASSET_TYPE_SET:
            return {
                ...state,
                assetType: action.assetType,
                assetTypeDepreciateMode: action.assetType?.default_depreciate_mode
          || state.assetTypeDepreciateMode,
            };
        case actions.ASSET_TYPE_SET_DEPRECIATE_MODE:
            return {
                ...state,
                assetTypeDepreciateMode: action.depreciateMode,
            };
        case actions.ASSET_TYPE_CREATE_REQUEST:
            return {
                ...state,
                createAssetTypeState: 'request',
            };
        case actions.ASSET_TYPE_CREATE_SUCCESS:
            return {
                ...state,
                createAssetTypeState: 'success',
            };
        case actions.ASSET_TYPE_CREATE_FAIL:
            return {
                ...state,
                createAssetTypeState: 'fail',
            };
        case actions.ASSET_TYPE_READ_LIST_REQUEST:
            return {
                ...state,
                readAssetTypeListState: 'request',
            };
        case actions.ASSET_TYPE_READ_LIST_SUCCESS:
            return {
                ...state,
                readAssetTypeListState: 'success',
                assetTypes: action.assetTypes,
            };
        case actions.ASSET_TYPE_READ_LIST_FAIL:
            return {
                ...state,
                readAssetTypeListState: 'fail',
            };
        case actions.ASSET_TYPE_READ_REQUEST:
            return {
                ...state,
                readAssetTypeState: 'request',
            };
        case actions.ASSET_TYPE_READ_SUCCESS: {
            const { assetType } = action;

            // Update useful life if PERIOD
            if (assetType.default_depreciate_mode === 'PERIOD') {
                assetType.default_useful_life = (
                    `${assetType.default_useful_years};${assetType.default_useful_months}`
                );
            }

            return {
                ...state,
                readAssetTypeState: 'success',
                assetType,
                assetTypeDepreciateMode: assetType.default_depreciate_mode,
            };
        }
        case actions.ASSET_TYPE_READ_FAIL:
            return {
                ...state,
                readAssetTypeState: 'fail',
            };
        case actions.ASSET_TYPE_UPDATE_REQUEST:
            return {
                ...state,
                updateAssetTypeState: 'request',
            };
        case actions.ASSET_TYPE_UPDATE_SUCCESS:
            return {
                ...state,
                updateAssetTypeState: 'success',
            };
        case actions.ASSET_TYPE_UPDATE_FAIL:
            return {
                ...state,
                updateAssetTypeState: 'fail',
            };
        case actions.ASSET_TYPE_DELETE_REQUEST:
            return {
                ...state,
                deleteAssetTypeState: 'request',
            };
        case actions.ASSET_TYPE_DELETE_SUCCESS:
            return {
                ...state,
                deleteAssetTypeState: 'success',
            };
        case actions.ASSET_TYPE_DELETE_FAIL:
            return {
                ...state,
                deleteAssetTypeState: 'fail',
            };
            /* ASSET DEPRECIATIONS */
        case actions.ASSET_DEPRECIATION_READ_DATE_LIST_REQUEST:
            return {
                ...state,
                readAssetDepreciationDateListState: 'request',
            };
        case actions.ASSET_DEPRECIATION_READ_DATE_LIST_SUCCESS:
            return {
                ...state,
                readAssetDepreciationDateListState: 'success',
                depreciationDates: action.depreciationDates,
            };
        case actions.ASSET_DEPRECIATION_READ_DATE_LIST_FAIL:
            return {
                ...state,
                readAssetDepreciationDateListState: 'fail',
            };
        case actions.ASSET_DEPRECIATION_PREVIEW_REQUEST:
            return {
                ...state,
                previewAssetDepreciationState: 'request',
            };
        case actions.ASSET_DEPRECIATION_PREVIEW_SUCCESS:
            return {
                ...state,
                previewAssetDepreciationState: 'success',
                previewDepreciations: action.previewDepreciations,
            };
        case actions.ASSET_DEPRECIATION_PREVIEW_FAIL:
            return {
                ...state,
                previewAssetDepreciationState: 'fail',
            };
        case actions.ASSET_DEPRECIATION_CREATE_REQUEST:
            return {
                ...state,
                createAssetDepreciationState: 'request',
            };
        case actions.ASSET_DEPRECIATION_CREATE_SUCCESS:
            return {
                ...state,
                createAssetDepreciationState: 'success',
            };
        case actions.ASSET_DEPRECIATION_CREATE_FAIL:
            return {
                ...state,
                createAssetDepreciationState: 'fail',
            };
        case actions.ASSET_DEPRECIATION_DELETE_LIST_REQUEST:
            return {
                ...state,
                deleteAssetDepreciationListState: 'request',
            };
        case actions.ASSET_DEPRECIATION_DELETE_LIST_SUCCESS:
            return {
                ...state,
                deleteAssetDepreciationListState: 'success',
            };
        case actions.ASSET_DEPRECIATION_DELETE_LIST_FAIL:
            return {
                ...state,
                deleteAssetDepreciationListState: 'fail',
            };
            /* ASSETS */
        case actions.ASSET_READ_PURCHASE_LIST_REQUEST:
            return {
                ...state,
                readPurchaseListState: 'request',
            };
        case actions.ASSET_READ_PURCHASE_LIST_SUCCESS:
            return {
                ...state,
                readPurchaseListState: 'success',
                purchases: action.purchases,
            };
        case actions.ASSET_READ_PURCHASE_LIST_FAIL:
            return {
                ...state,
                readPurchaseListState: 'fail',
            };
        case actions.ASSET_SET:
            return {
                ...state,
                asset: action.asset,
                assetDepreciateMode: action.asset.depreciate_mode,
                assetPurchaseDate: action.asset.purchase_date, // string
                assetDepreciationStartDate: action.asset.depreciation_start_date, // string
                assetIsDepreciated: action.asset.is_depreciated,
            };
        case actions.ASSET_SET_DEPRECIATE_MODE:
            return {
                ...state,
                assetDepreciateMode: action.depreciateMode,
            };
        case actions.ASSET_SET_PURCHASE_DATE:
            return {
                ...state,
                assetPurchaseDate: action.purchaseDate,
            };
        case actions.ASSET_SET_DEPRECIATION_START_DATE:
            return {
                ...state,
                assetDepreciationStartDate: action.depreciationStartDate,
            };
        case actions.ASSET_SET_IS_DEPRECIATED:
            return {
                ...state,
                assetIsDepreciated: action.isDepreciated,
            };
        case actions.ASSET_CREATE_REQUEST:
            return {
                ...state,
                createAssetState: 'request',
            };
        case actions.ASSET_CREATE_SUCCESS:
            return {
                ...state,
                createAssetState: 'success',
            };
        case actions.ASSET_CREATE_FAIL:
            return {
                ...state,
                createAssetState: 'fail',
            };
        case actions.ASSET_READ_LIST_REQUEST:
            return {
                ...state,
                readAssetListState: 'request',
            };
        case actions.ASSET_READ_LIST_SUCCESS:
            return {
                ...state,
                readAssetListState: 'success',
                assets: action.assets,
                pagination: {
                    total: action.pagination.total,
                    current: action.pagination.current_page,
                    pageSize: action.pagination.per_page,
                },
                lastDepreciated: action.lastDepreciated,
            };
        case actions.ASSET_READ_LIST_FAIL:
            return {
                ...state,
                readAssetListState: 'fail',
            };
        case actions.ASSET_READ_REQUEST:
            return {
                ...state,
                readAssetState: 'request',
            };
        case actions.ASSET_READ_SUCCESS: {
            const { asset } = action;
            // Update useful life if PERIOD
            if (asset.depreciate_mode === 'PERIOD')
                asset.useful_life = `${asset.useful_years};${asset.useful_months}`;

            return {
                ...state,
                readAssetState: 'success',
                asset,
                depreciations: action.depreciations,
                assetDepreciateMode: asset.depreciate_mode,
                assetPurchaseDate: asset.purchase_date, // string
                assetDepreciationStartDate: asset.depreciation_start_date, // string
                assetIsDepreciated: asset.is_depreciated,
            };
        }
        case actions.ASSET_READ_FAIL:
            return {
                ...state,
                readAssetState: 'fail',
            };
        case actions.ASSET_UPDATE_REQUEST:
            return {
                ...state,
                updateAssetState: 'request',
            };
        case actions.ASSET_UPDATE_SUCCESS:
            return {
                ...state,
                updateAssetState: 'success',
            };
        case actions.ASSET_UPDATE_FAIL:
            return {
                ...state,
                updateAssetState: 'fail',
            };
        case actions.ASSET_DELETE_REQUEST:
            return {
                ...state,
                deleteAssetState: 'request',
            };
        case actions.ASSET_DELETE_SUCCESS:
            return {
                ...state,
                deleteAssetState: 'success',
            };
        case actions.ASSET_DELETE_FAIL:
            return {
                ...state,
                deleteAssetState: 'fail',
            };
        case actions.ASSET_DISPOSAL_SET:
            return {
                ...state,
                disposal: action.disposal,
                disposalAmount: action.disposal.amount,
                disposalLastDepreciationType: action.disposal.last_depreciation_type,
                disposalLastDepreciationDate: action.disposal.last_depreciation_date,
            };
        case actions.ASSET_DISPOSAL_SET_AMOUNT:
            return {
                ...state,
                disposalAmount: action.disposalAmount,
            };
        case actions.ASSET_DISPOSAL_SET_LAST_DEPRECIATION_TYPE:
            return {
                ...state,
                disposalLastDepreciationType: action.disposalLastDepreciationType,
            };
        case actions.ASSET_DISPOSAL_SET_LAST_DEPRECIATION_DATE:
            return {
                ...state,
                disposalLastDepreciationDate: action.disposalLastDepreciationDate,
            };
        case actions.ASSET_DISPOSE_REQUEST:
            return {
                ...state,
                disposeAssetState: 'request',
            };
        case actions.ASSET_DISPOSE_SUCCESS:
            return {
                ...state,
                disposeAssetState: 'success',
            };
        case actions.ASSET_DISPOSE_FAIL:
            return {
                ...state,
                disposeAssetState: 'fail',
            };
        case actions.ASSET_UNDISPOSE_REQUEST:
            return {
                ...state,
                undisposeAssetState: 'request',
            };
        case actions.ASSET_UNDISPOSE_SUCCESS:
            return {
                ...state,
                undisposeAssetState: 'success',
            };
        case actions.ASSET_UNDISPOSE_FAIL:
            return {
                ...state,
                undisposeAssetState: 'fail',
            };
            /* OTHERS */
        case actions.ASSET_RESET_STATE:
            return {
                ...initState,
            };
            /* Editable Table Related */
        case actions.ASSET_SET_EDIT_LINE:
            return {
                ...state,
                editLine: action.line,
            };
        case actions.ASSET_EDIT_PREV_LINE: {
            idx = state.items.findIndex(item => item.line === state.editLine); // current line.

            const editLine = (
                (idx !== -1 && state.items[idx - 1]) ?
                    state.items[idx - 1].line :
                    state.editLine
            );

            return {
                ...state,
                editLine,
            };
        }
        case actions.ASSET_EDIT_NEXT_LINE: {
            idx = state.items.findIndex(item => item.line === state.editLine); // current line.

            const editLine = (
                (idx !== -1 && state.items[idx + 1]) ?
                    state.items[idx + 1].line :
                    state.editLine
            );

            return {
                ...state,
                editLine,
            };
        }
        case actions.ASSET_SET_FOCUSED_ELEMENT:
            return {
                ...state,
                focusedElement: action.element,
            };
        case actions.ASSET_SET_ITEMS:
            return {
                ...state,
                items: action.items,
            };
        case actions.ASSET_SET_ITEM: // Support partial update (Must have line)
            items = [...state.items];

            // Merge the item
            idx = items.findIndex(item => item.line === action.item.line);
            item = {...items[idx], ...action.item};

            // Merge back to items
            items[idx] = item;
            items = items.map((item, idx) => ({...item, idx: idx + 1}));

            return {
                ...state,
                items,
            };
        case actions.ASSET_ADD_ITEM: { // Add to the end of the list
            const { item } = action;

            item.line = parseInt(Math.random() * 1000000000, 10); // Random
            item.key = item.line.toString();

            const items = [
                ...state.items,
                item,
            ].map((item, idx) => ({
                ...item,
                idx: idx + 1,
            }));

            return {
                ...state,
                items,
                editLine: action.editItem ? item.line : state.editLine,
            };
        }
        case actions.ASSET_ADD_ITEMS: { // Add to the end of the list
            const actionItems = action.items.map(item => ({
                ...item,
                line: parseInt(Math.random() * 1000000000, 10), // Random
                key: item.line.toString(),
            }));

            const items = [
                ...state.items,
                ...actionItems,
            ].map((item, idx) => ({
                ...item,
                idx: idx + 1,
            }));

            return {
                ...state,
                items,
            };
        }
        case actions.ASSET_REMOVE_ITEM: // Delete from the list
            items = [...state.items];
            idx = items.findIndex(item => item.line === action.line);
            items.splice(idx, 1);
            items = items.map((item, idx) => ({...item, idx: idx + 1}));

            return {
                ...state,
                items,
                editLine: action.line === state.editLine ? null : state.editLine,
            };
        case actions.ASSET_BULK_CREATE_REQUEST:
            return {
                ...state,
                createBulkAssetState: 'request',
            };
        case actions.ASSET_BULK_CREATE_SUCCESS:
            return {
                ...state,
                createBulkAssetState: 'success',
                createResult: action.data,
            };
        default:
            return state;
    }
}
